<template>
  <BaseModalBackdrop v-if="value" class="alert__wrapper">
    <div class="alert__modal">
      <div class="alert__img" />
      <div class="alert__title" v-html="title"></div>
      <div class="alert__text" v-on:click.prevent="onNoteClick" v-html="text"></div>
      <div v-if="reRelease" class="alert__btn" v-on:click.prevent="onClickReRelease" v-html="translate('alert:re-release')"></div>
      <div class="alert__btn" v-on:click.prevent="onClick" v-html="btntext"></div>
    </div>
  </BaseModalBackdrop>
</template>

<script>
import '@/scss/alert.scss'

import BaseModalBackdrop from '@/components/ui/BaseModalBackdrop/BaseModalBackdrop'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'

export default {
  name: 'Alert.vue',
  components: {
    BaseModalBackdrop
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    title: {
      required: true,
      type: String
    },
    text: {
      required: false,
      type: String
    },
    btntext: {
      required: false,
      type: String,
      default: 'OK'
    },
    reRelease: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  created () {
    document.getElementsByTagName('body')[0]
      .style.overflow = 'hidden'
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0]
      .style.overflow = 'auto'
  },
  methods: {
    onClick () {
      this.$emit('input', false)
    },
    onClickReRelease () {
      this.$store.dispatch('goldkidProcess/component', 'reRelease')
    },
    onNoteClick (e) {
      if (e.target.classList.contains('egov')) {
        sendAnalyticEvent('online_child_gold_egov_click', {
          started_from: [this.$store.getters['app/urlParams'].startedFrom],
          stage: ['start'],
          inner_source: 'online_child_gold_landing',
          page_path: ['/bank/bpm/products/goldkids/goldkid'],
          external_message_id: [this.$store.getters['goldkidProcess/pId']]
        })
      }
    }
  }
}
</script>
